export const ROOM_BOOKING_NEEDS_ACTION_COUNT_CHANGED_EVENT =
  'room-booking-needs-action-count-changed';

export function notifyRoomBookingNeedsActionCountChanged(): void {
  window.dispatchEvent(new Event(ROOM_BOOKING_NEEDS_ACTION_COUNT_CHANGED_EVENT));
}
